import { useState, useCallback } from 'react'

export interface UseDisclosureReturn<T = unknown> {
  isOpen: boolean
  data: T | null
  open: (data?: T) => void
  close: () => void
  toggle: () => void
}

export const useDisclosure = <T = unknown,>(initOpened: boolean = false): UseDisclosureReturn<T> => {
  const [isOpen, setIsOpen] = useState(initOpened)
  const [data, setData] = useState<T | null>(null)

  const open = useCallback((data?: T) => {
    setData(data ?? null)
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setData(null)
  }, [])

  const toggle = useCallback(() => {
    setIsOpen((prevOpened) => {
      if (prevOpened) setData(null)
      return !prevOpened
    })
  }, [])

  return { isOpen, data, open, close, toggle }
}
